import { useCallback, useEffect, useState } from "react";
import { API } from "@/lib/api";

export const useWaTemplates = (adminKey) => {
  const [templates, setTemplates] = useState([]);
  const [configured, setConfigured] = useState(true);
  const load = useCallback(async () => {
    try {
      const res = await fetch(`${API}/admin/whatsapp-api/status`, { headers: { "X-PL-Client": "web", "X-Admin-Key": adminKey } });
      const data = res.ok ? await res.json() : { configured: false };
      setConfigured(!!data.configured);
      setTemplates((data.templates || []).filter((t) => t.status === "APPROVED"));
    } catch {
      setConfigured(false);
    }
  }, [adminKey]);
  useEffect(() => { load(); }, [load]);
  return { templates, configured, reload: load };
};
